import { Phone, Mail, MapPin } from "lucide-react";
import { useSearchParams } from "react-router-dom";
import SEO from "@/components/site/SEO";
import QuoteForm from "@/components/site/QuoteForm";
import BusinessHours from "@/components/site/BusinessHours";
import { COMPANY } from "@/lib/constants";

export default function Contact() {
  const [params] = useSearchParams();
  const service = params.get("service") || "";
  const ref = params.get("ref");
  const extraInspiration = ref ? [ref] : [];
  return (
    <div>
      <SEO title="Contact & Free Quote | CG Concrete LLC — Watertown, WI" description="Request a free concrete estimate from CG Concrete LLC in Watertown, WI. Upload project photos for a faster, more accurate quote. Call (920) 253-5606." />
      <section className="bg-secondary text-white grain-texture">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 lg:py-24">
          <span className="text-primary font-bold text-sm tracking-widest">GET IN TOUCH</span>
          <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-extrabold mt-3">Request Your Free Quote</h1>
          <p className="text-white/70 mt-5 text-lg max-w-2xl">Fill out the form below — add photos of your project for the fastest, most accurate estimate.</p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid lg:grid-cols-3 gap-10">
        <div className="lg:col-span-2 order-2 lg:order-1">
          <QuoteForm defaultService={service} extraInspiration={extraInspiration} />
        </div>
        <div className="order-1 lg:order-2 space-y-6">
          <div className="bg-card border border-border p-6">
            <h3 className="font-heading text-xl font-bold mb-4">Contact Info</h3>
            <ul className="space-y-4 text-sm">
              <li className="flex items-start gap-3"><Phone className="h-5 w-5 text-primary mt-0.5" /><div><div className="font-semibold">Phone</div><a href={`tel:${COMPANY.phoneRaw}`} className="text-muted-foreground hover:text-primary">{COMPANY.phone}</a></div></li>
              <li className="flex items-start gap-3"><Mail className="h-5 w-5 text-primary mt-0.5" /><div><div className="font-semibold">Email</div><a href={`mailto:${COMPANY.email}`} className="text-muted-foreground hover:text-primary break-all">{COMPANY.email}</a></div></li>
              <li className="flex items-start gap-3"><MapPin className="h-5 w-5 text-primary mt-0.5" /><div><div className="font-semibold">Location</div><span className="text-muted-foreground">{COMPANY.address}, {COMPANY.city}, {COMPANY.state}</span></div></li>
            </ul>
          </div>
          <BusinessHours />
          <div className="border border-border overflow-hidden">
            <iframe
              title="CG Concrete service area map"
              src="https://www.google.com/maps?q=Watertown,WI&output=embed"
              className="w-full h-64"
              loading="lazy"
            />
          </div>
        </div>
      </section>
    </div>
  );
}
